import { render, staticRenderFns } from "./AlternateAccountLookup.vue?vue&type=template&id=374c7df2&scoped=true"
import script from "./AlternateAccountLookup.vue?vue&type=script&lang=js"
export * from "./AlternateAccountLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c7df2",
  null
  
)

export default component.exports